"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./RangeField.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
    Range field
    
    Returns a component that allows the user
    to choose for certain options within a range

    Verified by: Yorben Verhoest
    Date: 06/12/2019
    identityBuilding bvba
    https://identitybuilding.be
*/
// Our main component
var RangeField = function RangeField(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rangeField"
  }, props.labels && /*#__PURE__*/_react["default"].createElement("div", {
    className: "rangeLabels"
  }, /*#__PURE__*/_react["default"].createElement("div", null, props.labels[0]), /*#__PURE__*/_react["default"].createElement("div", null, props.labels[1])), /*#__PURE__*/_react["default"].createElement("input", {
    "aria-label": props.label,
    className: "rangeSlider",
    min: props.min ? props.min : '0',
    max: props.max ? props.max : '10',
    onChange: function onChange(e) {
      return props.onChange ? props.onChange(e.target.value) : undefined;
    },
    type: "range",
    value: props.value
  }), props.value && props.valueLabel && /*#__PURE__*/_react["default"].createElement("div", {
    className: "rangeFieldValueWrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rangeFieldValue"
  }, props.value)));
};

var _default = RangeField;
exports["default"] = _default;